import React from 'react'
import { PseudoBox, Image, Box, Text, Flex } from '@chakra-ui/core'
import useLocaleText from 'components/useLocaleText'
import excelIcon from 'assets/icons8-excel-96.png'
import { DataSourceOption } from '../constants'
import { ModalTitle, ModalSubtitle } from '../styles'

interface ReportsStepProps {
  selectedDataSource: DataSourceOption
  setSelectedDataSource: (option: DataSourceOption) => void
}

export const ReportsStep: React.FC<ReportsStepProps> = ({ selectedDataSource, setSelectedDataSource }) => {
  const data_popup_title = useLocaleText('data_popup_title', true)
  const data_popup_desc = useLocaleText('data_popup_desc', true)
  const data_btn_1 = useLocaleText('data_btn_1', true)
  const data_btn_1_desc = useLocaleText('data_btn_1_desc', true)
  const data_btn_2 = useLocaleText('data_btn_2', true)
  const data_btn_2_desc = useLocaleText('data_btn_2_desc', true)

  return (
    <>
      <ModalTitle>{data_popup_title}</ModalTitle>
      <ModalSubtitle>{data_popup_desc}</ModalSubtitle>
      <Flex style={{ gap: '10px' }} w="100%" mb="24px">
        <PseudoBox
          display="flex"
          flexDir="row"
          bg={selectedDataSource === 'demo' ? '#007A3E' : '#009F52'}
          style={{ gap: '10px' }}
          borderRadius="20px"
          p="10px"
          w="50%"
          cursor="pointer"
          onClick={() => setSelectedDataSource('demo')}
          border={selectedDataSource === 'demo' ? '3px solid #005A2E' : '3px solid transparent'}
          transform={selectedDataSource === 'demo' ? 'scale(1.02)' : 'scale(1)'}
          transition="all 0.2s ease"
          _hover={{
            opacity: 0.9,
          }}
        >
          <Image src={excelIcon} alt="Excel Icon" width="48x" height="48px" />
          <Box textAlign="left">
            <Text fontSize="16px" fontWeight="600" color="white">
              {data_btn_1}
            </Text>
            <Text fontSize="14px" fontWeight="400" color="white">
              {data_btn_1_desc}
            </Text>
          </Box>
        </PseudoBox>
        <PseudoBox
          display="flex"
          flexDir="column"
          justifyContent="center"
          borderRadius="20px"
          p="10px"
          w="50%"
          border={selectedDataSource === 'connect' ? '3px solid #f005c5' : '1px solid #000000'}
          bg={selectedDataSource === 'connect' ? '#fdf2f8' : 'transparent'}
          cursor="pointer"
          textAlign="center"
          transform={selectedDataSource === 'connect' ? 'scale(1.02)' : 'scale(1)'}
          transition="all 0.2s ease"
          onClick={() => setSelectedDataSource('connect')}
          _hover={{
            background: selectedDataSource === 'connect' ? '#fdf2f8' : '#f5f5f5',
          }}
        >
          <Text fontSize="16px" fontWeight="600">
            {data_btn_2}
          </Text>
          <Text fontSize="14px" fontWeight="400" px="20px">
            {data_btn_2_desc}
          </Text>
        </PseudoBox>
      </Flex>
    </>
  )
}
